module.exports = __webpack_public_path__ + "files/8642dbfe531a38f6ab836f629ff93485.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-700italic.woff
// module id = 875
// module chunks = 60